import {head,indexOf} from "lodash"
import { isGeminiUser } from "../../utils/sessionUtil";

export const checkCSRBusinessFunction = (businessFunction, businessFunctionArray) => {
    return isGeminiUser() ?
        (businessFunctionArray.length === 1 && head(businessFunctionArray) === 'Administration'.toLowerCase()) ? false : businessFunction && indexOf(businessFunctionArray, businessFunction.toLowerCase()) === -1 :
        false
};

export const convertArrayElemToLowerCase = array => array.map(element => element.toLowerCase());